import { Component } from '@angular/core';

import { NavParams, PopoverController } from '@ionic/angular';
import { Router } from '@angular/router';
import { NavUrls } from '../../../enums/nav-urls';

import { AlertService, AlertDialogButtonClick } from '../../../services/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { EnterpriseCustomerV2Dto } from 'src/app/api/exa';
import { EnterpriseCustomerService } from 'src/app/services/enterprise-customer.service';

@Component({
  selector: '',
  templateUrl: './customer-context-menu.component.html',
  styleUrls: ['../popover.component.scss'],
})
export class CustomerContextMenuComponent {
  // @Input()
  customerDto: EnterpriseCustomerV2Dto;

  hasGrantToWriteCustomer: boolean;

  constructor(
    private navParams: NavParams,
    private router: Router,
    private popoverController: PopoverController,
    private alertService: AlertService,
    private translate: TranslateService,
    private enterpriseCustomerService: EnterpriseCustomerService
  ) {
    this.customerDto = this.navParams.data.customerDto;
    console.log('customerDto: ', this.customerDto);
    
    this.hasGrantToWriteCustomer = this.navParams.data.hasGrantToWriteCustomer;
  }

  // =========================== BUTTONS ====================================

  onClickEdit() {
    let this_customer_id = this.customerDto.id;
    this.router.navigateByUrl('/' + NavUrls.CUSTOMERS + '/' + NavUrls.ADDEDITCUSTOMER + '/' + this_customer_id);
    this.DismissClick();
  }

  onClickDelete() {
    //  console.log(" POPOVER presenting. Löschung von customer ", this.customerDto.id, "bestätigen: ");
    this.alertService
      .presentConfirmAlert(this.translate.instant('WARNING'), this.translate.instant('CUSTOMER.DELETE.QUESTION'))
      .then((buttonClick) => {
        if (buttonClick == AlertDialogButtonClick.OK) {
          let customerId = this.customerDto.id;

          this.enterpriseCustomerService.deleteCustomer(customerId).finally(() => {
            this.DismissClick();
          });
        }
      });
  }

  onClickActivate() {
    // set active property of user
    this.customerDto.active = true;
    let this_customerId = this.customerDto.id;
    this.enterpriseCustomerService.editCustomer(this_customerId, this.customerDto).then(
      (ret) => {
        console.log(' return: ', ret);
      },
      (err) => {
        console.log(' return: ', err);
      }
    );
    this.DismissClick();
  }

  onClickDeactivate() {
    // set active property of user
    // this.employeeDto.employeeState = EmployeeStateEnum.ACTIVE;
    this.customerDto.active = false;
    let this_customerId = this.customerDto.id;

    this.enterpriseCustomerService.editCustomer(this_customerId, this.customerDto).then(
      (ret) => {
        console.log(' return: ', ret);
      },
      (err) => {
        console.log(' return: ', err);
      }
    );
    this.DismissClick();
  }
  // =========================== MISC ====================================

  async DismissClick() {
    await this.popoverController.dismiss();
  }
}
